import React, { PureComponent } from 'react';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Tag } from 'antd';
import Link from 'umi/link';
import Debounce from 'lodash-decorators/debounce';
import { connect } from 'dva';
import styles from './index.less';
import RightContent from './RightContent';
import prodEnvConfig from '../../../config/prod-env-config';
import defaultSettings from '../../defaultSettings';

export default class GlobalHeader extends PureComponent {
  componentWillUnmount() {
    this.triggerResizeEvent.cancel();
  }
  /* eslint-disable*/
  @Debounce(600)
  triggerResizeEvent() {
    // eslint-disable-line
    const event = document.createEvent('HTMLEvents');
    event.initEvent('resize', true, false);
    window.dispatchEvent(event);
  }
  toggle = () => {
    const { collapsed, onCollapse } = this.props;
    onCollapse(!collapsed);
    this.triggerResizeEvent();
  };
  render() {
    const { collapsed, isMobile, logo, whiteLabel } = this.props;
    const { cloudnosysVersion } = defaultSettings;
    // console.log('⛑ GLOBAL HEADER rerendering');
    return (
      <div className={styles.headerRedefined}>
        <div style={{ display: 'inline' }}>
          <span className={styles.trigger} onClick={this.toggle}>
            <LegacyIcon type={collapsed ? 'menu-unfold' : 'menu-fold'} />
          </span>
          <span>
            <Link to="/" className={styles.logo} key="logo">
              <img
                src={whiteLabel?.isActive ? whiteLabel.logoUrl : logo}
                alt="logo"
                height={
                  whiteLabel?.isActive && whiteLabel.logoUrl.includes('visionetsystems')
                    ? '30'
                    : '50'
                }
                style={{ marginTop: -4 }}
              />
            </Link>

            <sub style={{ top: '-3px', marginLeft: '6px' }}>
              <Tag
                style={{
                  fontSize: '8px',
                  height: '18px',
                  border: 0,
                  background: '#d9d9d99c',
                  color: 'black',
                }}
              >
                V {cloudnosysVersion}
              </Tag>
            </sub>
          </span>
        </div>
        <RightContent {...this.props} />
      </div>
    );
  }
}
